module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey detalj 2023 3.d131d98c.jpg";